import Pusher from "pusher-js";
import type { Events } from "./utils/types.ds";

interface IPusher {
	cluster: string;
	appKey: string;
}
/**
 *
 */
export class PusherService {
	private pusherClient: Pusher;
	constructor({ cluster, appKey }: IPusher) {
		this.pusherClient = new Pusher(appKey, {
			cluster,
		});
	}

	public subscribeToChannels(event: Events | Events) {
    const channel = this.pusherClient.subscribe(event.channel);

    for (const channelEvent of event.channelEvents) {
      channel.bind(channelEvent.eventName, channelEvent.callback);
    }
	}
	public unSubscribeToChannels(event: Events): void {
    this.pusherClient.unsubscribe(event.channel)
	}
}
